<template>
  <div></div>
</template>

<script>
import { mapGetters } from 'vuex'
import userRole from '@/mixins/userRole'
export default {
  name: 'ipasas',
  mixins: [userRole],
  computed: {
    ...mapGetters(['userAgreement']),
  },
  created() {
    this.ipasasAuth()
  },
  methods: {
    ipasasAuth() {
      if (this.$route.query.enc) {
        if(this.$route.query.accessibility){
          this.$store.dispatch('changeForAccessibility', this.$route.query.accessibility == '1')
        }
        this.loading = true
        this.$store
          .dispatch('ipasasLogin', { enc: this.$route.query.enc })
          .then(() => {
            this.$store.dispatch('loadTooltips')
            this.$store.dispatch('loadNotifications')
            this.$store.dispatch('changeLanguage', {
              lang: 'lt',
              i18n: this.$i18n,
            })
            this.$axios.get(`system-notifications/application/self-service`).then((res) => {
              this.$store.dispatch('systemNotification', res.data)
            })
            this.loading = false
            this.$router.push({ name: 'home' })
          })
          .catch(() => {
            this.loading = false
          })
      } else {
        this.$store.dispatch('keepAlive', false)
        this.$router.push({ name: 'login' })
      }
    },
  },
}
</script>
